module.exports = __webpack_public_path__ + "static/media/TEMPLATE2.ba5bc01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE2.jpg
// module id = 1468
// module chunks = 1